import React, { Component } from 'react';

class CircularProgressBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showSelected: '',
            showCP: false,
        }
    }

    render() {
        const { progressPer } = this.props;
        return (
            <div className="circular-progress" data-percentage={progressPer || 0}>
                <span className="progress-left">
                    <span className="progress-bar"></span>
                </span>
                <span className="progress-right">
                    <span className="progress-bar"></span>
                </span>
                <div className="progress-value">
                    <div>
                        {progressPer || 0}<span>%</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default CircularProgressBar;